import React, {Component} from 'react'
import styled, { css } from 'styled-components'
import { media } from '../../styles/utils'

import { ribbon } from '../../styles/colors'
import { button } from '../../styles/global';

class Submit extends Component {


    render() {
        return (
            <Wrapper>
                <Button
                    className={this.props.className}
                    onClick={this.props.handleSubmit}      
                >
                    {this.props.label}
                </Button>
            </Wrapper>
        )
    }
}

const Wrapper = styled.div`
    text-align: center;
`

export const Button = styled.button`
    ${button};
    cursor: pointer;
    text-align: center;
`

export default Submit;



// WEBPACK FOOTER //
// ./src/components/Submit/Submit.js